import { buildColorPool } from '@/models/Util'
import Opportunity from '@/models/Opportunity'
import SystemDashboardWidget from '@/models/SystemDashboardWidget'
import { startCase } from 'lodash'
import moment from 'moment'
import numeral from 'numeral'

export default class CountByStageWidget extends SystemDashboardWidget {
  public title: string = `Count by Stage ${moment().format('YYYY')}`

  public key: string = 'opp-by-stage'

  public view: string = 'chart'

  public subView: string = 'funnel'

  public loaderSize: string = '350px'

  public dimensions: string[] = ['status']

  public metrics: string[] = ['count']

  public size: any = {
    lg: 4,
    md: 12,
  }

  constructor(args: any = null) {
    super()

    if (args && args.dimensions) {
      this.dimensions = args.dimensions
    }

    if (args && args.metrics) {
      this.metrics = args.metrics
    }

    if (args && args.filters) {
      this.filters = Object.assign(this.filters, args.filters)
    }
    if (args && args.internalFilters) {
      this.internalFilters = Object.assign(this.internalFilters, args.internalFilters)
    }

    if (args && args.rightCol) {
      this.rightCol = args.rightCol
    }

    if (args && args.leftCol) {
      this.leftCol = args.leftCol
    }

    if (args && args.size) {
      this.size = args.size
    }

    if (args && args.title) {
      this.title = args.title
    }

    if (args && args.key) {
      this.key = args.key
    }

    if (args && args.internalQuery) {
      this.internalQuery = args.internalQuery
    }

    if (args && args.internalQueryPush) {
      this.internalQuery.push(args.internalQueryPush)
    }
  }

  // API Filters
  public filters: any = {
    region: 'all',
    product: 'all',
  }

  public internalFilters: any = {
    year: moment().format('YYYY'),
  }

  public get filterToQuery() {
    let query = []

    if (this.filters.product !== 'all') {
      query.push(`product:${this.filters.product}`)
    }

    if (this.filters.region !== 'all') {
      query.push(`region:${this.filters.region}`)
    }

    query.push(`year:${this.internalFilters.year}`)

    return query
  }

  public formatters: any = {
    label: (widget: SystemDashboardWidget, value: any, opt: any) => {
      const raw_value = widget.rawData[opt.dataPointIndex].count
      const label = widget.chartSettings.labels[opt.dataPointIndex]

      return [`${label}: ${numeral(raw_value).format('0')}`]
    },
    tooltip: (widget: SystemDashboardWidget, value: any, opt: any) => {
      const raw_value = widget.rawData[opt.dataPointIndex].count
      const total = widget.rawData.reduce(
        (acc: number, item: any) => acc + item[widget.metrics[0]],
        0,
      )

      return [`${numeral(raw_value).format('0')}`, ` ${numeral(raw_value / total).format('0.00%')}`]
    },
  }

  public internalQuery: string[] = ['scope:agency']

  public get payload() {
    const query = [...new Set([...this.query, ...this.internalQuery, ...this.filterToQuery])]

    return {
      dimensions: this.dimensions,
      metrics: this.metrics,
      filters: {
        ...this.internalFilters,
      },
      order: {
        percentage: 'asc',
      },
      query,
    }
  }

  public dataSource() {
    return Opportunity.buildAdvancedQuery(this.payload).then((res: any) => res.data.result)
  }

  protected dataMapper(data: any): Promise<any> {
    const data_series: any[] = []
    const labels: string[] = []
    const colors: string[] = []
    let total = 0

    const color_pool = buildColorPool(data.length, true)

    // Init Series
    let count = 0
    const total_count = data.length
    data.forEach((item: any, idx: number) => {
      const val = Number(item[this.metrics[0]])
      total += val

      let label = startCase(item[this.dimensions[0]])
      labels.push(label)
      colors.push(color_pool(count++))
      data_series.push(total_count - count + 1)
    })

    // Udpate Settings
    this.chartSettings.colors = colors
    this.chartSettings.xaxis = {
      categories: labels,
    }
    this.chartSettings.labels = labels

    return Promise.resolve([
      {
        name: startCase(this.metrics[0]),
        data: data_series,
      },
    ])
  }
}
